import { IAdminAlert } from "../../../../@types/admin/AdminAlert";
import { TableSorted } from "../../../../components/TableSorted";
import { usePatientTriggeredAlerts } from "../../../../hooks/queries/admin/patients";
import {
  ErrorMessage,
  ModalContainer,
  ModalHeader,
  ModalSubtitle,
  ModalTitle,
} from "../AdminPage.styles";
import { useTriggeredAlertColumns } from "../PatientDetailsPanel/triggeredAlertColumns";
import { TableContainer } from "../TableContainer";
import { TableLoadingState } from "../TableStates";
import { TableWrapper } from "../TableWrapper";

interface ITriggeredAlertsModalProps {
  alert: IAdminAlert;
}

/**
 * The alerts that have FIRED for this row's patient, opened from the admin
 * Alerts table (EN-5146). Same data and columns as the Patients page's
 * Monitoring tab — Retool's `modulePatientAlerts` — so an operator can go
 * from "what is configured" to "what actually went off" without leaving
 * the page.
 */
export function TriggeredAlertsModal({ alert }: ITriggeredAlertsModalProps) {
  const { triggeredAlerts, isLoading, isError } = usePatientTriggeredAlerts(
    alert.patientId
  );
  const columns = useTriggeredAlertColumns();

  return (
    <ModalContainer>
      <ModalHeader>
        <ModalTitle>Triggered alerts</ModalTitle>
        <ModalSubtitle>
          {alert.patientEmail ?? `Patient ${alert.patientId}`}
        </ModalSubtitle>
      </ModalHeader>

      {isError && (
        <ErrorMessage>
          Failed to load this patient&apos;s triggered alerts. Close the dialog
          and try again.
        </ErrorMessage>
      )}

      <TableContainer>
        <TableWrapper refreshKeys={[["admin-patient-triggered-alerts"]]}>
          <TableSorted
            columns={columns}
            data={triggeredAlerts}
            emptyStateText={
              isLoading ? (
                <TableLoadingState />
              ) : (
                "No alerts have fired for this patient"
              )
            }
          />
        </TableWrapper>
      </TableContainer>
    </ModalContainer>
  );
}
